import { ShakerFeatureDescriptor } from 'src/app/model/shaker-control/shaker-feature-descriptor';
import { deepFreeze } from '../deep-freeze';

/**
 * Feature descriptor for the TIME feature of shaker control sequence items.
 */
export const TIME_DESCRIPTOR: ShakerFeatureDescriptor = deepFreeze({
  id: 'TIME',
  name: 'Wait',
  unit: 'hh:mm:ss',
  max: undefined,
  min: 0,
  step: 1,
  colorHex: '#000000',
});
